"use client";
import * as React from "react";
const SvgMailRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14.4.5H1.6C.72.5 0 1.231 0 2.125v9.75c0 .894.72 1.625 1.6 1.625h12.8c.88 0 1.6-.731 1.6-1.625v-9.75C16 1.231 15.28.5 14.4.5Zm-.32 3.453L8.848 7.38a1.564 1.564 0 0 1-1.696 0L1.92 3.953a.698.698 0 0 1-.32-.585.68.68 0 0 1 1.04-.585L8 6.188l5.36-3.405a.68.68 0 0 1 1.04.585c0 .236-.12.455-.32.585Z" }));
export {
  SvgMailRound as default
};
